import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";

import {MODAL_ONLY_SEARCH_PARAMS} from "../helpers/get_listing_layout_search_key";

export function usePageLinkBuilder() {
    const location = useLocation();

    return (page: number) => {
        // modal-only params describe transient UI state, they must not leak into pagination urls
        const search = omit(parseSearch(location.search), MODAL_ONLY_SEARCH_PARAMS);
        const query = validateQuery(["page"], search, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };
}
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";

import {MODAL_ONLY_SEARCH_PARAMS} from "../helpers/get_listing_layout_search_key";

export function usePageLinkBuilder() {
    const location = useLocation();

    return (page: number) => {
        // modal-only params describe transient UI state, they must not leak into pagination urls
        const search = omit(parseSearch(location.search), MODAL_ONLY_SEARCH_PARAMS);
        const query = validateQuery(["page"], search, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };
}
